module.exports = __webpack_public_path__ + "static/prototyping-fd4076225d3573b9676f8e3880ce4ff6.svg";